import React, { useEffect } from 'react';
import { Row } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { intlShape } from '../../../components/base/IntlProviderWrapper';
import { infoFormatterIntl } from '../../../utils/formatters';
import './authorized.scss';
import { Accordion } from '../../../components/base/Accordion/Accordion';

export function UserPassportDataView(props) {
  const {
    user = {},
  } = props;
  const {
    formatMessage,
  } = intlShape;

  const isResident = user?.citizenship === 'RUS';

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div className="f3">{formatMessage({ id: 'user.profile.menu.passport' })}</div>
        <div className="f4 export-title">
          Экспорт данных
        </div>
      </div>
      <Row className="row-cols-1 mb-4">
        {infoFormatterIntl('citizenship', formatMessage({ id: `citizenship.${user?.citizenship}` }), {}, 'user.citizenship')}
      </Row>
      <div className="f4 mb-3"> {formatMessage({ id: 'user.profile.uzbek.passport.data' })}</div>
      <Row className="row-cols-3 mb-2">
        {infoFormatterIntl('last_name', user.last_name, {}, 'user.last_name')}
        {infoFormatterIntl('first_name', user.first_name, {}, 'user.first_name')}
        {infoFormatterIntl('middle_name', user.middle_name, {}, 'user.middle_name')}
      </Row>
      <Row className="row-cols-3 mb-2">
        {infoFormatterIntl('user.passport_series', user.series, {}, 'user.passport_series')}
        {infoFormatterIntl('user.passport_number', user.number, {}, 'user.passport_number')}
        {infoFormatterIntl('user.passport_issue_date', user.issue_date, {}, 'user.passport_issue_date')}
      </Row>
      <Row className="row-cols-3 mb-2">
        {infoFormatterIntl('user.passport_expiry_date', user.expiry_date, {}, 'user.passport_expiry_date')}
        {infoFormatterIntl('birth_date', user.birth_date, {}, 'user.birth_date')}
        {infoFormatterIntl('user.birth_place', user.birth_place, {}, 'user.birth_place')}
      </Row>
      <Row className="row-cols-1 mb-2">
        {infoFormatterIntl('user.passport_issuer', user.issuer, {}, 'user.passport_issuer')}
      </Row>
      <div className="divider mb-2" />
      {isResident ? (
        <Accordion
          title={formatMessage({ id: 'user.profile.external.passport.data' })}
          content={(
            <>
              <Row className="row-cols-3 mb-2">
                {infoFormatterIntl('last_name', user.last_name, {}, 'user.last_name')}
                {infoFormatterIntl('first_name', user.first_name, {}, 'user.first_name')}
                {infoFormatterIntl('middle_name', user.middle_name, {}, 'user.middle_name')}
              </Row>
              <Row className="row-cols-3 mb-2">
                {infoFormatterIntl('user.passport_series', user.series, {}, 'user.passport_series')}
                {infoFormatterIntl('user.passport_number', user.number, {}, 'user.passport_number')}
                {infoFormatterIntl('user.passport_issue_date', user.issue_date, {}, 'user.passport_issue_date')}
              </Row>
              <Row className="row-cols-3 mb-2">
                {infoFormatterIntl('user.passport_expiry_date', user.expiry_date, {}, 'user.passport_expiry_date')}
                {infoFormatterIntl('birth_date', user.birth_date, {}, 'user.birth_date')}
                {infoFormatterIntl('user.birth_place', user.birth_place, {}, 'user.birth_place')}
              </Row>
            </>
          )}
        />
      ) : (
        <>
          <Accordion
            title={formatMessage({ id: 'user.profile.residence.permit' })}
            content={(
              <Row className="row-cols-3 mb-2">
                {infoFormatterIntl('user.residence_permit_series', user?.series, {}, 'user.residence_permit_series')}
                {infoFormatterIntl('user.residence_permit_number', user?.number, {}, 'user.residence_permit_number')}
                {infoFormatterIntl('user.residence_permit_issue_date', user?.issue_date, {}, 'user.residence_permit_issue_date')}
              </Row>
            )}
          />
          <Accordion
            title={formatMessage({ id: 'user.profile.temporary.residence' })}
            content={(
              <>
                <Row className="row-cols-3 mb-2">
                  {infoFormatterIntl('user.temporary_residence_series', user?.series, {}, 'user.temporary_residence_series')}
                  {infoFormatterIntl('user.temporary_residence_number', user?.number, {}, 'user.temporary_residence_number')}
                  {infoFormatterIntl('user.temporary_residence_issue_date', user?.issue_date, {}, 'user.temporary_residence_issue_date')}
                </Row>
                <Row className="row-cols-3 mb-2">
                  {infoFormatterIntl('user.temporary_residence_decision_number', user?.decision_number, {}, 'user.temporary_residence_decision_number')}
                  {infoFormatterIntl('user.temporary_residence_decision_date', user?.decision_date, {}, 'user.temporary_residence_decision_date')}
                  {infoFormatterIntl('user.temporary_residence_expiry_date', user?.expiry_date, {}, 'user.temporary_residence_expiry_date')}
                </Row>
              </>
            )}
          />
          <Accordion
            title={formatMessage({ id: 'user.profile.patent' })}
            content={(
              <Row className="row-cols-3">
                {infoFormatterIntl('user.patent_series', user?.series, {}, 'user.patent_series')}
                {infoFormatterIntl('user.patent_number', user?.number, {}, 'user.patent_number')}
                {infoFormatterIntl('user.patent_issue_date', user?.patent?.issue_date, {}, 'user.patent_issue_date')}
              </Row>
            )}
          />
        </>
      )}
    </div>
  );
}
